import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";
import { getDocNumbering } from "../../../../../CommonAppRedux/DocNumbering/thunk";

// get saleOrderRequest
export const getSaleOrderRequest = createAsyncThunk(
  "saleOrderRequest/getSaleOrderRequest",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getSaleOrderRequest({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all saleOrderRequest
export const getAllSaleOrderRequest = createAsyncThunk(
  "saleOrderRequest/getAllSaleOrderRequest",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllSaleOrderRequest();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("saleOrderRequest/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("saleOrderRequest/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "saleOrderRequest/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageSaleOrderRequest({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getSaleOrderRequestById = createAsyncThunk(
  "saleOrderRequest/getSaleOrderRequestById",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await API.getSaleOrderRequestById(id);

      let docNumberingData = ""; // Store getDocNumbering response

      // Dispatch getDocNumbering if branchId exists
      if (data?.data?.branch?.id) {
        const docNumberingResponse = await dispatch(
          getDocNumbering({
            type: "sor",
            branchId: data.data.branch.id,
          })
        );

        // Extract data from fulfilled action
        if (docNumberingResponse?.payload) {
          docNumberingData = docNumberingResponse.payload?.data[0] || "";
        }
      }

      if (data?.data?.purchaseOrderRequest.purchaseOrderRequestDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.purchaseOrderRequest?.purchaseOrderRequestDetails.map(
          async (detail) => {
            const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

            if (stockData.data?.length > 0) {
              return {
                ...detail,
                // availableStock stock from stockData
                availableStock: stockData.data[0]?.closingStock || "",
              };
            } else {
              return {
                ...detail,
                availableStock: 0,
              };
            }
          }
        );

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return {
          ...data,

          data: {
            ...data.data,
            docNumberingData: docNumberingData,

            purchaseOrderRequest: {
              ...data.data.purchaseOrderRequest,
              purchaseOrderRequestDetails: updatedDetails,
            },
          },
        };
      } else {
        return { ...data, data: { ...data.data, docNumberingData: docNumberingData } };
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create saleOrderRequest
export const createSaleOrderRequest = createAsyncThunk(
  "saleOrderRequest/createSaleOrderRequest",
  async (createData, { rejectWithValue }) => {
    const {
      salesOrderRequest,
      indentNo,
      isFromHo,
      termsOfDelivery,
      requiredDateAd,
      voucherDateBs,
      voucherDate,
      branch,
      status,
      documentsAttach,
      refVoucher,
      saleOrderDetails,
      grandTotal,
    } = createData;
    try {
      const body = JSON.stringify({
        salesOrderRequest,
        indentNo,
        isFromHo,
        termsOfDelivery,
        requiredDateAd,
        branch,
        status,
        voucherDateBs,
        voucherDate,
        refVoucher,
        termsOfDelivery,
        termOfPayment: 1,
        saleOrderDetails,
        grandTotal,
      });
      // const body = new FormData();

      // Object.entries(createData).forEach(([key, value]) => {
      //   if (key !== "documentsAttach" && key !== "saleOrderRequestDetails") {
      //     body.append(key, value);
      //   }
      // });
      // documentsAttach?.length > 0 &&
      //   documentsAttach?.forEach((document, i) => {
      //     body.append(`documentsAttach[${i}]`, document);
      //   });
      // saleOrderRequestDetails?.length > 0 &&
      //   saleOrderRequestDetails?.forEach((detail, i) => {
      //     body.append(`purchaseOrderRequestDetails[${i}].product`, detail.product);
      //     body.append(`purchaseOrderRequestDetails[${i}].vendor`, detail.vendor);
      //     body.append(`purchaseOrderRequestDetails[${i}].actualQuantity`, detail.actualQuantity);
      //     body.append(`purchaseOrderRequestDetails[${i}].unit`, detail.unit);
      //     body.append(`purchaseOrderRequestDetails[${i}].rate`, detail.rate);
      //     body.append(`purchaseOrderRequestDetails[${i}].amount`, detail.amount);
      //     body.append(`purchaseOrderRequestDetails[${i}].requiredDate`, detail.requiredDate);

      //     body.append(`purchaseOrderRequestDetails[${i}].closingStock`, detail.closingStock);

      //     body.append(`purchaseOrderRequestDetails[${i}].description`, detail.description);

      //     body.append(`purchaseOrderRequestDetails[${i}].altQuantity`, detail.altQuantity);

      //     body.append(`purchaseOrderRequestDetails[${i}].altUnit`, detail.altUnit);
      //   });
      const { data } = await API.createSaleOrderRequest(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateSaleOrderRequest = createAsyncThunk(
  "saleOrderRequest/updateSaleOrderRequest",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const {
      salesOrderRequest,
      indentNo,
      isFromHo,
      requiredDateAd,
      voucherDateBs,
      voucherDate,
      branch,
      status,
      documentsAttach,
      // refVoucher,
      saleOrderDetails,
      grandTotal,
    } = values;
    try {
      const body = JSON.stringify({
        salesOrderRequest,
        indentNo,
        isFromHo,
        requiredDateAd,
        branch,
        status,
        voucherDateBs,
        voucherDate,
        // refVoucher,
        saleOrderDetails,
        grandTotal,
      });
      const { data } = await API.updateSaleOrderRequest(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "saleOrderRequest/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
